import { GAME_TIMEZONE } from "./constants.js";
/**
 * Verilen anın oyun takvimindeki gün anahtarı ("YYYY-MM-DD").
 * Gün sınırı Türkiye saatine göre gece yarısıdır, böylece tüm oyuncular
 * aynı anda yeni günlük kelimeye geçer.
 */
export function dayKey(date = new Date(), timeZone = GAME_TIMEZONE) {
    // "en-CA" biçimi YYYY-MM-DD üretir.
    return new Intl.DateTimeFormat("en-CA", {
        timeZone,
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
    }).format(date);
}
const DAY_MS = 24 * 60 * 60 * 1000;
/**
 * Bir sonraki günlük kelimeye kalan süre (ms).
 *
 * Kullanıcının kendi saat dilimi ne olursa olsun geri sayım Türkiye'deki gece
 * yarısını gösterir — gün sınırı orada. Hesap "Türkiye'de gece yarısından bu
 * yana geçen süre" üzerinden yapılıyor; sabit bir UTC farkı varsaymıyoruz.
 */
export function msUntilNextDay(now = Date.now(), timeZone = GAME_TIMEZONE) {
    const parts = new Intl.DateTimeFormat("en-GB", {
        timeZone,
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hourCycle: "h23",
    }).formatToParts(new Date(now));
    const value = (type) => Number(parts.find((part) => part.type === type)?.value ?? 0);
    // Saat dilimi farkları tam dakika olduğu için saniyenin kesri doğrudan alınır.
    const sinceMidnight = ((value("hour") * 60 + value("minute")) * 60 + value("second")) * 1000 +
        ((now % 1000) + 1000) % 1000;
    return DAY_MS - sinceMidnight;
}
/** FNV-1a 32-bit — kısa, deterministik, platformdan bağımsız. */
export function fnv1a(input) {
    let hash = 0x811c9dc5;
    for (let i = 0; i < input.length; i++) {
        hash ^= input.charCodeAt(i);
        // 32-bit FNV prime ile çarpım, taşmayı önlemek için Math.imul
        hash = Math.imul(hash, 0x01000193);
    }
    return hash >>> 0;
}
/**
 * Gün anahtarını cevap havuzundaki bir indekse çevirir.
 * `secret` sunucuda kalır; böylece istemci ileri tarihli kelimeleri hesaplayamaz.
 */
export function dailyIndex(key, poolSize, secret) {
    if (poolSize <= 0)
        throw new Error("Cevap havuzu boş");
    return fnv1a(`${key}:${secret}`) % poolSize;
}
//# sourceMappingURL=daily.js.map